import { client } from '@admin/libraries/apollo';
import { AutoDispatchPermissionsUpdateDocument, Status } from '@admin/schema';

import { DispatcherData, DispatcherDispatchRecord } from './dispatcher_types';

const isAutoDispatchEnabled = (dispatch: DispatcherDispatchRecord) => dispatch.auto_dispatch_enabled !== false;

export const syncAutoDispatchPermissions = async (
  editorData: DispatcherData,
  baselineData: DispatcherData,
): Promise<void> => {
  const baselineById = new Map(
    baselineData.dispatches
      .filter((dispatch) => dispatch.id != null)
      .map((dispatch) => [Number(dispatch.id), isAutoDispatchEnabled(dispatch)]),
  );

  for (const dispatch of editorData.dispatches) {
    if (dispatch.id == null || dispatch._destroy) {
      continue;
    }

    const dispatchId = Number(dispatch.id);
    const baselineEnabled = baselineById.get(dispatchId);
    if (baselineEnabled === undefined) {
      continue;
    }

    const nextEnabled = isAutoDispatchEnabled(dispatch);
    if (nextEnabled === baselineEnabled) {
      continue;
    }

    const { data } = await client.mutate({
      mutation: AutoDispatchPermissionsUpdateDocument,
      variables: { id: String(dispatch.id), autoDispatchEnabled: nextEnabled },
    });

    const payload = data?.result;
    if (payload?.status !== Status.Ok) {
      throw new Error(payload?.error || 'Unable to update auto-dispatch.');
    }

    if (typeof dispatch.lock_version === 'number') {
      dispatch.lock_version += 1;
    }
  }
};
